// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";

import infiniteScroll from "vue-infinite-scroll";

Vue.use(Vuetify);
Vue.use(infiniteScroll);

export default new Vuetify({
  icons: {
    iconfont: "mdiSvg",
  },
});
